import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Protected } from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import VerifyEmail from "@/pages/VerifyEmail";
import Privacy from "@/pages/Privacy";
import ForFamilies from "@/pages/ForFamilies";
import ForCaregivers from "@/pages/ForCaregivers";
import ForAgencies from "@/pages/ForAgencies";
import HomeCareServices from "@/pages/HomeCareServices";
import SeniorCareMatching from "@/pages/SeniorCareMatching";
import CaregiverMatching from "@/pages/CaregiverMatching";
import HowItWorks from "@/pages/HowItWorks";
import BookAppointment from "@/pages/BookAppointment";
import Faqs from "@/pages/Faqs";
import Sitemap from "@/pages/Sitemap";
import Intake from "@/pages/Intake";
import IntakeDone from "@/pages/IntakeDone";
import CaregiverApply from "@/pages/CaregiverApply";
import AgencyApply from "@/pages/AgencyApply";
import ClientPortal from "@/pages/Client";
import CaregiverPortal from "@/pages/Caregiver";
import AgencyPortal from "@/pages/Agency";
import Office from "@/pages/Office";
import Matching from "@/pages/Matching";
import Disputes from "@/pages/Disputes";
import Ledger from "@/pages/Ledger";
import Vetting from "@/pages/Vetting";
import CarePreferences from "@/pages/CarePreferences";
import CarePlan from "@/pages/CarePlan";
import ManageStaff from "@/pages/ManageStaff";
import Availability from "@/pages/Availability";
import Profile from "@/pages/Profile";

const STAFF = ["gm", "compliance", "marketing", "recruitment", "training", "hr", "retention", "support", "nurse"];

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/staff" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/for-families" element={<ForFamilies />} />
          <Route path="/for-caregivers" element={<ForCaregivers />} />
          <Route path="/for-agencies" element={<ForAgencies />} />
          <Route path="/home-care-services" element={<HomeCareServices />} />
          <Route path="/senior-care-matching" element={<SeniorCareMatching />} />
          <Route path="/caregiver-matching" element={<CaregiverMatching />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/get-matched" element={<Navigate to="/intake" replace />} />
          <Route path="/caregiver-membership" element={<Navigate to="/caregiver-apply" replace />} />
          <Route path="/partner-agencies" element={<Navigate to="/for-agencies" replace />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/intake-done" element={<IntakeDone />} />
          <Route path="/caregiver-apply" element={<CaregiverApply />} />
          <Route path="/agency-apply" element={<AgencyApply />} />

          <Route path="/client" element={<Protected roles={["client"]}><ClientPortal /></Protected>} />
          <Route path="/caregiver" element={<Protected roles={["caregiver"]}><CaregiverPortal /></Protected>} />
          <Route path="/agency" element={<Protected roles={["agency"]}><AgencyPortal /></Protected>} />

          <Route path="/office" element={<Protected roles={STAFF}><Office /></Protected>} />
          <Route path="/matching" element={<Protected roles={STAFF}><Matching /></Protected>} />
          <Route path="/disputes" element={<Protected roles={STAFF}><Disputes /></Protected>} />
          <Route path="/ledger" element={<Protected roles={STAFF}><Ledger /></Protected>} />
          <Route path="/vetting" element={<Protected roles={STAFF}><Vetting /></Protected>} />
          <Route path="/care-preferences" element={<Protected roles={STAFF}><CarePreferences /></Protected>} />
          <Route path="/careplan" element={<Protected roles={STAFF}><CarePlan /></Protected>} />
          <Route path="/manage-staff" element={<Protected roles={["gm"]}><ManageStaff /></Protected>} />
          <Route path="/availability" element={<Protected roles={STAFF}><Availability /></Protected>} />

          <Route path="/profile" element={<Protected><Profile /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
